import { FC } from "react";
import { useTranslationUpdater } from "./TranslationUpdater.hook";
import { TranslationUpdaterList } from "./TranslationUpdaterList";
import { ProdConfirmationModal } from "./ProdConfirmationModal";
import "./style.css";

export const TranslationUpdater: FC = () => {
  const {
    state,
    onUpdateUatEnvClick,
    onUpdateProdEnvClick,
    onUpdateInternalEnvClick,
    onUpdateProdEnvConfirm,
    onUpdateProdModalClose,
  } = useTranslationUpdater();

  const {
    envs,
    internalEnvs,
    currentPickedEnv,
    updatingState,
    disableState,
    isProdUpdateConfirmationModalOpen,
  } = state;

  return (
    <div className="translation-updater-wrapper">
      <h2 className="translation-updater-wrapper-header">
        Internal environments
      </h2>
      <div className="translation-updater-environment-list internal">
        <TranslationUpdaterList
          envs={internalEnvs}
          disableState={disableState}
          updatingState={updatingState}
          version="internal"
          onUpdateInternalEnvClick={onUpdateInternalEnvClick}
          onUpdateProdEnvClick={onUpdateProdEnvClick}
        />
      </div>
      <h2 className="translation-updater-wrapper-header">Environments</h2>
      <div className="translation-updater-environment-list">
        <TranslationUpdaterList
          envs={envs}
          disableState={disableState}
          updatingState={updatingState}
          version="external"
          onUpdateInternalEnvClick={onUpdateUatEnvClick}
          onUpdateProdEnvClick={onUpdateProdEnvClick}
        />
      </div>
      <ProdConfirmationModal
        isOpen={isProdUpdateConfirmationModalOpen}
        onConfirm={onUpdateProdEnvConfirm}
        onClose={onUpdateProdModalClose}
      >
        <h3 data-testid="prod-confirmation-modal-header">
          Are you sure you want to update <p>{currentPickedEnv?.name} PROD?</p>
        </h3>
      </ProdConfirmationModal>
    </div>
  );
};
